<template>
    <div class="py-5">
        <form id="ng" @submit.stop>
            <div class="p-0 mt-5 mb-3 pt-5 text-right" style="border: none!important;">
                <category-selector :edit="true"
                                   :edit-category="Object.keys(data).length > 0 ? data.category  : category"
                                   ref="category"
                                   :multiAdsCat="false">
                </category-selector>
                <div class="col-md-11 mx-auto">
                    <div class="col-md-8 mx-auto px-0">
                        <city-selector :multi-neighbor="true" :multi-city="true" :edit-city="Object.keys(data).length > 0 ? data.city :city"
                                       :edit-neighbor="Object.keys(data).length > 0 ?data.neighborhood : neighborhood"
                                       ref="city"
                                       :force="true"></city-selector>
                    </div>
                    <div class="col-md-8 mx-auto px-0" v-if="edit">
                        <v-text-field @keypress="allowOnlyNumbers($event)" label="شماره مشاور" outlined
                                      prepend-inner-icon="fa fa-pencil-alt"
                                      dense v-model="mobile"
                                      maxlength="11" counter
                        ></v-text-field>
                    </div>
                </div>
                <div v-if="edit" class="col-md-8 text-left mr-auto">
                    <v-btn @click="submitAgent" class="submit-btn">
                        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        ثبت مشاور
                    </v-btn>
                </div>
                <div v-if="!edit" class="col-md-8 text-left mr-auto">
                    <v-btn @click="updateAgent" class="submit-btn">
                        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        به روزرسانی مشاور
                    </v-btn>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TitleRibbon from "../../uiBeautifier/titleRibbon";
import CategorySelector from "../divarDependency/categorySelector";
import CitySelector from "../divarDependency/citySelector";
import {Bus} from "../../../../main";

export default {
    name: "newAgent",
    components: {
        CitySelector, CategorySelector, TitleRibbon
    },
    props: {
        tab: {
            default: function () {
            }
        },
        modal: {
            default: function () {
            },
            type:Function
        },
        reload: {
           type:Function,
        },
        edit: {
            default: false
        },
        data: {
            default: {}
        }
    },
    data() {
        return {
            id: '',
            mobile: '',
            category: 'real_estate',
            city: '',
            neighborhood: '',
        }
    },
    methods: {
        submitAgent() {
            $.ajax({
                url: `${url}/user/agents`,
                method: "POST",
                fn: this.submitAgent,
                headers: {
                    Authorization: Token,
                    ACCEPT: 'application/json',
                    "Content-Type": "application/json"
                },
                msg: true,
                data: JSON.stringify({
                    "user_id": this.mobile,
                    "category": this.category,
                    "neighborhood": this.neighborhood,
                    "city": this.city,
                }),
                success: () => {
                    this.tab();
                }
            });
        },
        updateAgent() {
            $.ajax({
                url: `${url}/user/agents/${this.data.id}`,
                method: "PUT",
                fn: this.updateAgent,
                headers: {
                    Authorization: Token,
                    ACCEPT: 'application/json',
                    "Content-Type": "application/json"
                },
                msg: true,
                data: JSON.stringify({
                    "category": this.category,
                    "neighborhood": this.neighborhood,
                    "city": this.city,
                }),
                success: () => {
                    this.reload();
                    this.modal();
                }
            });
        },
        allowOnlyNumbers(value) {
            let allowedKeys = [8, 46, 38, 40, 37, 39];
            const keypressed = value.which || value.keyCode;
            if (/[^0-9\s]+/.test(value.key)) {
                if (allowedKeys.every(e => e !== keypressed)) {
                    value.preventDefault();
                }
            } else return true
        },
        resetAgent() {
            this.id = '';
            this.mobile = '';
            this.category = 'real_estate';
            this.$refs.city.cityInfo.city = '';
            this.$refs.city.cityInfo.neighborhood = '';
        }
    },
    mounted() {
        if (this.city === '' || this.neighborhood === '') {
            Bus.$on('cityInfo', (value) => {
                this.city = value.city;
                if (value.neighborhood != null || value.neighborhood !== '') {
                    this.neighborhood = value.neighborhood;
                }
            });
        }
        Bus.$on('category-current', (current) => {
            this.category = current;
        });
    }
}
</script>

<style scoped>

</style>